import React, { useState,useEffect, useRef } from 'react';
import {formatDDMMYYYY,formatYYYYMMDD,urlApiProd,eliminarDiacriticosEs,formatCurrency,print} from '../utiles';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Card from 'react-bootstrap/Card';
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
//import coherentpdf from 'coherentpdf';
import pdfToText from "react-pdftotext";
import { pdfjs } from "react-pdf";



const AgregarSolicitud = ({ solicitudes, solicitudesInternas, puertos, ffw, carriers, cerrar }) => {
    const [formData, setFormData] = useState({
        codigo: '',
        nro_booking: '',
        id_ffw: -1,
        id_carrier: -1,
        id_puerto_origen: -1,
        id_puerto_destino: -1,
        ftorigen: '',
        ftdestino: '',
        nave: '',
        etd: '',
        eta: null,
        dlc: null,
        dld: null,
        cantidad: '',
        flete: '',
        estado: 0,
        requerimientos: '',
        cargo_weight: 'Payload',
        tipo_carga: '40HC Supertestado',
        id_solicitud_interna: '',
        tipo_bl: '',
        idflete:-1,
        idtasa:-1,
        id_creador: localStorage.getItem('ID_Usuario'),
        invoice: 0,
        estado_retiro: null,
        estado_bl: null,
        gate_in: null,
        categoria_booking: '',
        mapa: '',
        cross_docking:'',
    });
    const [cantidadMaxima, setCantidadMaxima] = useState(99);
    const [solicitudInterna, setSolicitudInterna] = useState(null);
    const [pedidoCompletado, setPedidoCompletado] = useState(false);
    const [valor, setValor] = React.useState(0);
    const firstRender = useRef(true);
    const [currentRadioValue, setCurrentValue] = React.useState('BL Original');
    const [dataCalcularTasas, setdataCalcularTasas] = useState([]);
    const [filter, setFilter] = useState('');
    const [precioSeleccionado, setprecioSeleccionado] = useState('');
    const [erroresForm, seterroresForm] = useState('');
    const [idSolicitud, setIdSolicitud] = useState('');


     const fetchData = async () => {
            const token = localStorage.getItem('token');
            try {
                // Fetch Solicitudes Internas
                const response = await fetch(`${urlApiProd}/calcular_preciobooking`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error('Error fetching datos calculo preciobooking');
                const data= await response.json();
                //print(`'Edata:', ${data}`);
                setdataCalcularTasas(data);
                //setTotalItems(total);
                //setPrincipal(true);
            } catch (error) {
                print(`'Error en fetchData:', ${error.message}`);
                //setPrincipal(false); // Indica que la solicitud principal falló
                toast.error(`Precios tasas bookings no cargadas: ${error.message}`, { toastId: 'error-principal' });
            }
        };

        useEffect(() => {
                if (firstRender.current) {
                    //setLoading(true);
                    fetchData();
                    firstRender.current = false;
                }
            }, []);

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setValor(value);
    };

    const seleccionarCalculoTasa = (e) => {
        setprecioSeleccionado(e.idflete*10+e.idtasa*100);
        setValor((((e.totalbrsxctnr/Number(filter))+e.totalusdxctnr)*e.frete*formData.cantidad)+((e.totalbrsxbl/Number(filter)+e.totalusdxbl)));
        setFormData({ ...formData, ['ftorigen']: e.freetime_origen, ['ftdestino'] : e.freetime_destino, ['flete'] : e.frete, ['id_ffw'] : e.ffw, ['id_carrier'] : e.armador, ['idflete'] : e.idflete, ['idtasa'] : e.idtasa,});
    }
    
    const handleRadioChange = value1 => {
        const { name, value } = value1.target;
        setFormData({ ...formData, [name]: value });
      };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        //print(`name ${name} value ${value} `);
    };

    const handleChangeUpperCase = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };


    const [showCorreo, setShowCorreo] = React.useState(false);
      
        const handleClose = () => {setShowCorreo(false);
            cerrar();
        };
        const handleShowCorreo = () => {
            if(formData.id_ffw>-1)
                setShowCorreo(true);
        };

        const handleCloseCancelar = () => {

            setShowCorreo(false);

        };

        const getSaludo = () => {
            const horaActual = new Date().getHours();
            //print(horaActual);
            return horaActual < 12 ? 'Bom dia' : 'Boa tarde';
        };

        const handleCopiarCorreo = () => {
            navigator.clipboard.writeText(correoContenido).then(() => {
                alert('Correo copiado al portapapeles.');
            }).catch(() => {
                alert('Error al copiar el correo.');
            });
        };

  const handleEnviarCorreo = async () => {
    
        const ffwSeleccionado = ffw.find(ffw => ffw.id_ffw === parseInt(formData.id_ffw));
        const email = ffwSeleccionado?.correo_contacto[0] || 'destinatario@example.com'; // Email por defecto
        const subject = encodeURIComponent('Solicitações e bookings');
        const body = encodeURIComponent(correoContenido);
    
        // Abrir cliente de correo
        const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
        window.location.href = mailtoLink;
    
        const token = localStorage.getItem('token');
        formData.estado=1;
        try {
            const response = await fetch(
                `${urlApiProd}/editsolicitudbooking/${idSolicitud}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify(formData) // Cambiar estado a 2
                }
            );
            if (!response.ok) {
                alert('Correo enviado y estado de solicitud actualizado.');
            } else if(solicitudInterna){
                //solicitudInterna.estado=2;
                /*
                try {
                    const response1 = await fetch(`${urlApiProd}/modificarsolicitudinterna`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify(solicitudInterna)
                    });
                    if (!response1.ok) throw new Error('Error al modificar la solicitud interna');
                    //alert('Solicitud interna modificada exitosamente');
                    cerrar();
                } catch (error) {
                    console.error('Error:', error);
                    alert('No se pudo modificar la solicitud interna');
                }
                */
            }    
        } catch (error) {
            alert('Hubo un problema al actualizar las solicitudes. Por favor verifica manualmente.');
        }
       
    };

const [correoContenido, setCorreoContenido] = useState('');
    const EnviarCorreoBooking = () =>  {

        const ffwSeleccionado = ffw.find(ffw => ffw.id_ffw === parseInt(formData.id_ffw));
        //print(`ffwSeleccionado ${ffwSeleccionado} origen ${puertos.find(p => p.id_puerto === formData.id_puerto_origen)?.nombre || ''} destino ${puertos.find(p => p.id_puerto === formData.id_puerto_destino)?.nombre || ''} carrier ${carriers.find(c => c.id_carrier === formData.id_carrier)?.nombre || ''}`);
        const saludo = getSaludo(); 
        const origen = puertos.find(p => p.id_puerto.toString() === formData.id_puerto_origen.toString())?.nombre || ''; 
        const destino = puertos.find(p => p.id_puerto.toString() === formData.id_puerto_destino.toString())?.nombre || '';
        const carrier = carriers.find(c => c.id_carrier.toString() === formData.id_carrier.toString())?.nombre || '';
        const cuerpoCorreo = `
ETD: ${formatDDMMYYYY(formData.etd)}
REF: ${formData.codigo}
Quantidade: ${formData.cantidad}x40HC Supertestado
Cargo Weight: ${formData.cargo_weight}
POL: ${origen}
POD: ${destino}
Armador: ${carrier}
Frete: USD $${formData.flete}.
Free time Brasil: ${formData.ftorigen}
Free time destino: ${formData.ftdestino}

${formData.requerimientos} `;
useEffect(() => {
setCorreoContenido(`
    ${saludo} ${ffwSeleccionado ? ffwSeleccionado.nombre_contacto[0] : ''},
    
    Tudo bem?
    
    ${cuerpoCorreo}
    Ficamos no aguardo dos BKs confirmados.
    
    Muito obrigado e boa semana.
    
    Saludos,
            `)},
         []);

        return (
          <>
            <Button variant="primary" size="lg" onClick={handleSubmit} style={{marginTop:5}}>
            Guardar Solicitud de Booking
            </Button>
            <div>{erroresForm}</div>

      
            <Modal show={showCorreo} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Armar Correo de booking?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <div className="mb-3">
                                    <label className="form-label">Contenido del Correo</label>
                                    <textarea
                                        className="form-control"
                                        value={correoContenido}
                                        rows="10"
                                        readOnly
                                    ></textarea>
                                </div> 
                                <div className="mb-3"> 
                                <button
                                    type="button"
                                    className="btn btn-secondary me-2"
                                    onClick={handleCopiarCorreo}
                                >Copiar Correo
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handleEnviarCorreo}
                                >
                                    Armar Correo
                                </button>
                                
                                         </div>                    
              </Modal.Body>
            </Modal>

          </>
        );
      };

      function timeout(delay) {
        return new Promise( res => setTimeout(res, delay) );
    }

    const handleSubmit = async (e) => {
        //e.preventDefault();
        
        if (!formData.codigo.trim() || formData.id_puerto_origen===-1 || formData.id_puerto_destino===-1 || !formData.etd || !formData.cantidad || !formData.flete || formData.id_carrier===-1 || formData.cantidad>cantidadMaxima) {
           // alert('Por favor, complete todos los campos obligatorios.');
            seterroresForm('⚠️ Favor revisar información ⚠️');
            await timeout(2000);
            seterroresForm('');
            return;
        }

        if(formData.id_solicitud_interna === '') {
            formData.id_solicitud_interna = null;
        }
        if(formData.nro_booking!==''){
              formData.estado=2;
        }

        const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${urlApiProd}/addsolicitudbooking`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al agregar la solicitud');
            } else{
                const respuesta = await response.json();
                setIdSolicitud(respuesta.id);
                print(`response.json() ${respuesta.id}`);
                print(`${solicitudInterna}`);
                if(solicitudInterna && response.ok && solicitudInterna.cantidad===(formData.cantidad+(solicitudInterna.cantidad_solicitada ?? 0))){
                    print('solicitudInterna.cantidad==solicitudInterna.cantidadFaltante', `${solicitudInterna.cantidad}===${solicitudInterna.cantidad_solicitada}`);
                    const responseSolicitudInterna = await fetch(`${urlApiProd}/editsolicitudinterna/${solicitudInterna.id_solicitudinterna}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({ ...solicitudInterna, cantidad_solicitada: (formData.cantidad+(solicitudInterna.cantidad_solicitada ?? 0)) })
                    });
                    if (!responseSolicitudInterna.ok) {
                        const errorData = await responseSolicitudInterna.json();
                        throw new Error(errorData.error || 'Error al modificar la solicitud interna');
                    }
                    //alert('Solicitud Interna actualizada exitosamente');
                    solicitudInterna.cantidad_solicitada = (formData.cantidad+(solicitudInterna.cantidad_solicitada ?? 0));
                } else if(solicitudInterna && response.ok && solicitudInterna.cantidad>(formData.cantidad+(solicitudInterna.cantidad_solicitada ?? 0))){
                    print(`solicitudInterna.cantidad>solicitudInterna.cantidadFaltante${solicitudInterna.cantidad}===${solicitudInterna.cantidad_solicitada}`);
                    const responseSolicitudInterna = await fetch(`${urlApiProd}/editsolicitudinterna/${solicitudInterna.id_solicitudinterna}`, {
                        method: 'PUT',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({ ...solicitudInterna, cantidad_solicitada: (formData.cantidad+(solicitudInterna.cantidad_solicitada ?? 0)) })
                    });
                    if (!responseSolicitudInterna.ok) {
                        const errorData = await responseSolicitudInterna.json();
                        throw new Error(errorData.error || 'Error al modificar la solicitud interna');
                    } else{
                        solicitudInterna.cantidad_solicitada = (formData.cantidad+(solicitudInterna.cantidad_solicitada ?? 0));
                    }
                }
                else if(pedidoCompletado && !response.ok){
                    alert('No se pudo actualizar la solicitud interna, modificar manualmente');
                }
               //aca va
             //  if(formData.id_ffw>-1){
             //  handleShowCorreo();
             //   }
               
     
               alert('Solicitud guardada exitosamente');
               cerrar();     
            }
           
          
           
           
            
        } catch (error) {
            print(`Error: ${error}`);
            alert('No se pudo agregar la solicitud');
        }
    };

    const handleChangeLimited = async (e, max) => {
        const { name, value } = e.target;
        const numericValue = parseInt(value, 10);
    
        if (numericValue <= max) {
            setFormData({ ...formData, [name]: numericValue });
        } else {
            seterroresForm(`El valor máximo permitido es ${max} días.`);
            await timeout(2000);
            seterroresForm('');
            //alert(`El valor máximo permitido es ${max} días.`);
        }
    };

    const handleChangeSolicitudInterna = (e) => {
        const { name, value } = e.target;
        

        //solicitudesInternas.indexWhere

        const solicitudInterna = solicitudesInternas.find((solicitud) => solicitud.id_solicitudinterna.toString() === value.toString());
        //print(`solicitud_interna: {solicitudInterna}`);

        if(value.toString()==="-1"){
            setSolicitudInterna(null)
            setFormData({ ...formData, [name]: value, codigo:"", id_ffw:0, id_carrier:0, id_puerto_origen:0, id_puerto_destino:0, ftorigen:"", ftdestino:"", nave:"", etd: "", cantidad:"", flete:"", cargo_weight:"", requerimientos:"", id_solicitud_interna:-1});
        } else if(solicitudInterna!=null){
            setSolicitudInterna(solicitudInterna);
            const solicitudesAsociadas = solicitudes.filter((solicitud) => solicitud.id_solicitudinterna === solicitudInterna.id_solicitudinterna);
            setCantidadMaxima(solicitudInterna.cantidad - solicitudInterna.cantidad_solicitada);
            setFormData({ ...formData, [name]: value, etd: solicitudInterna.etd, id_puerto_destino: solicitudInterna.id_puerto_destino, freeTimeDestino: solicitudInterna.freeTimeDestino, requerimientos: solicitudInterna.requerimientos, tipo_bl:solicitudInterna.tipo_bl });

            print(`solicitudInterna.tipo_bl: ${solicitudInterna.tipo_bl ?? 'BL Original'}`);
            setCurrentValue(solicitudInterna.tipo_bl ?? 'BL Original');

        } else{
            alert(`Error encontrando solicitud interna`);
        }
        
    }

    const handleChangeCantidad = (e, maxi) => {
        const { name, value,min,max } = e.target;
        var value1 = 0;

        if(Number(value)<Number(maxi)){
            value1 = Number(value);     
            setFormData({ ...formData, [name]: value1>0 ? Number(value1) : '' });
        }
    }

    const handleUploadEverGreen = async (event)  => {
        const file = event.target.files[0];

         // Create a blob URL for the PDF file

         pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

         const blobUrl = URL.createObjectURL(file);
        

  // Load the PDF file
  const loadingTask = pdfjs.getDocument(blobUrl);

  let extractedText = "";

  try {
    const pdf = await loadingTask.promise;
    const numPages = pdf.numPages;

    var codreferencia = "";
    var nroBooking = "";
    var text = "";
    var navio = "";
    var origen = "";
    var ETD = "";
    var transitTime = "";
    var destino = "";
    var ETA = "";
    var cantidadContenedores = "";
    var freeTimeOrigen = "";
    var freeTimeDestino= "";
    var DLC= "";
    var DLD= "";

    // Iterate through each page and extract text
    for (let pageNumber = 1; pageNumber <= 1; pageNumber++) {
      const page = await pdf.getPage(pageNumber);
      const textContent = await page.getTextContent();
      const pageText = textContent.items
        .map((item) => ("str" in item ? item.str : ""))
        .join(" ");
        
        //el pdf de evergreen comienza con BOOKING
if(pageText.startsWith('BOOKING')){
        textContent.items.forEach( function(valor, index, array) {
            const linea = index +"%"+  valor.str+"%\n";

                print(linea);

                if(index===13){
                    try{
                    nroBooking = linea.split('%')[1].split('%')[0].trim();  
                }catch(e){}
                } else if(index===15){
                    try{
                    codreferencia = linea.split('.:')[1].split('%')[0];
                }catch(e){}
                } 
                else if(index===20){
                    try{
                    navio = linea.split('%')[1].split('%')[0]; 
                }catch(e){}
                } else if(index===22){
                    try{
                     if(navio!=='')   
                    navio = navio+" "+linea.split('%')[1].split('%')[0]; 
                }catch(e){}
                } else if(index===24){
                    try{
                     if(navio!=='' && !linea.includes('Estimated'))   
                    navio = navio+" "+linea.split('%')[1].split('%')[0]; 
                }catch(e){}
                } else if(index===51 || (index===53 && origen==='')){
                    try{
                        if(index===51)
                    origen = linea.split(':')[1].split(',')[0].trim(); 
                        if(index===53 && origen==='')
                            origen = linea.split(':')[1].split(',')[0].trim(); 
                }catch(e){}
                }  else if(index===57 || index===59){
                    try{
                     if(index===57)           
                    ETD = linea.split(':')[1].split('%')[0].replaceAll('/','-'); 
                        if(index===59 && ETD==='')
                            ETD = linea.split(':')[1].split('%')[0].replaceAll('/','-'); 
                }catch(e){}
                } else if(index===49){
                  //  transitTime = linea.split('(')[1].split(')')[0]; 
                } else if(index===69 || index===71){
                    try{
                        if(index===69)
                          ETA = linea.split(':')[1].split('%')[0].replaceAll('/','-'); 
                        if(index===71 && ETA==='')
                            ETA = linea.split(':')[1].split('%')[0].replaceAll('/','-');
                }catch(e){}
                } else if(index===63 || index===65){
                    try{
                        if(index===63)
                          destino = linea.split(':')[1].split(',')[0].trim(); 
                        if(index===65 && destino==='')
                            destino = linea.split(':')[1].split(',')[0].trim(); 
                }catch(e){}
                } else if((index===100 || index===102 || index===103 || index===104 || index===105 || index===107 || index===112 || (index===494 && !linea.includes('QUANTIDADE') && !linea.includes('===')) || (index===498) || index===502) && cantidadContenedores===''){
                    try{
                        if((index===100 && linea.includes(' /')) && !linea.includes('=') && !linea.includes(':') && !linea.includes('(') && !linea.includes('% %'))
                           cantidadContenedores = linea.split('%')[1].split(' ')[0].trim(); 
                        if(index===102 && cantidadContenedores==='' && !linea.includes('% %') && !linea.includes(' ') && !linea.includes('='))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===103 && cantidadContenedores==='' && !linea.includes('=') && !linea.includes('/') && !linea.includes('(') && !linea.includes(' '))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===104 && cantidadContenedores==='' && !linea.includes('=') && !linea.includes('% %') && !linea.includes('-'))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===105 && cantidadContenedores==='' && linea.includes('HI-CUBE'))
                            cantidadContenedores = linea.split('%')[1].split(' ')[0].trim(); 
                        if(index===105 && cantidadContenedores==='' && !linea.includes('/') && !linea.includes('% %'))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===107 && cantidadContenedores==='' && linea.includes('HI-CUBE'))
                            cantidadContenedores = linea.split('%')[1].split(' ')[0].trim(); 
                        if(index===107 && cantidadContenedores==='' && !linea.includes('% %'))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===112 && cantidadContenedores==='')
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                }catch(e){}
                } else if(index===52 || index===54){
                    try{
                        if(index===52)
                          DLC = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
                        if(index===54 && DLC==='')
                            DLC = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
                }catch(e){}
                } else if(index===53 || index===55){
                    try{
                        if(index===53)
                          DLD = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
                       else if(index===55 && DLD==='')
                          DLD = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
                }catch(e){}
                }
               
                
        });
        var porigen = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase()).includes(origen.toUpperCase()))?.id_puerto || -1;
        var pdestino = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase()).includes(destino.toUpperCase()))?.id_puerto || -1;
        print('porigen: '+porigen+' pdestino: '+pdestino)

          setFormData({ ...formData, codigo:codreferencia, nro_booking:nroBooking, nave:navio,etd:ETD,eta:ETA, cantidad:cantidadContenedores, id_carrier:6, id_puerto_origen:porigen,id_puerto_destino:pdestino, dlc: DLC, dld: DLD});
    }
        
      extractedText += pageText;
    }
  } catch (error) {
    throw new Error(`Failed to extract text from PDF: ${error}`);
  } finally {

    URL.revokeObjectURL(blobUrl);
    // Free memory from loading task
    loadingTask.destroy();
  }

      }

      const handleUploadMSC = async (event)  => {
        const file = event.target.files[0];

         // Create a blob URL for the PDF file

         pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.mjs`;

         const blobUrl = URL.createObjectURL(file);
        

  // Load the PDF file
  const loadingTask = pdfjs.getDocument(blobUrl);

  let extractedText = "";

  try {
    const pdf = await loadingTask.promise;
    const numPages = pdf.numPages;

    var codreferencia = "";
    var nroBooking = "";
    var text = "";
    var navio = "";
    var origen = "";
    var ETD = "";
    var transitTime = "";
    var destino = "";
    var ETA = "";
    var cantidadContenedores = "";
    var freeTimeOrigen = "";
    var freeTimeDestino= "";
    var DLC= "";
    var DLD= "";

    // Iterate through each page and extract text
    for (let pageNumber = 1; pageNumber <= 1; pageNumber++) {
      const page = await pdf.getPage(pageNumber);
      const textContent = await page.getTextContent();
      const pageText = textContent.items
        .map((item) => ("str" in item ? item.str : ""))
        .join(" ");
        
        //el pdf de evergreen comienza con BOOKING
if(pageText.startsWith('BOOKING') || 1===1){
        textContent.items.forEach( function(valor, index, array) {
            const linea = index +"%"+  valor.str+"%\n";

                print(linea);

                if(index===13){
                    try{
                    nroBooking = linea.split('%')[1].split('%')[0].trim();  
                }catch(e){}
                } else if(index===15){
                    try{
                    codreferencia = linea.split('.:')[1].split('%')[0];
                }catch(e){}
                } 
                else if(index===20){
                    try{
                    navio = linea.split('%')[1].split('%')[0]; 
                }catch(e){}
                } else if(index===22){
                    try{
                     if(navio!=='')   
                    navio = navio+" "+linea.split('%')[1].split('%')[0]; 
                }catch(e){}
                } else if(index===24){
                    try{
                     if(navio!=='' && !linea.includes('Estimated'))   
                    navio = navio+" "+linea.split('%')[1].split('%')[0]; 
                }catch(e){}
                } else if(index===51 || (index===53 && origen==='')){
                    try{
                        if(index===51)
                    origen = linea.split(':')[1].split(',')[0].trim(); 
                        if(index===53 && origen==='')
                            origen = linea.split(':')[1].split(',')[0].trim(); 
                }catch(e){}
                }  else if(index===57 || index===59){
                    try{
                     if(index===57)           
                    ETD = linea.split(':')[1].split('%')[0].replaceAll('/','-'); 
                        if(index===59 && ETD==='')
                            ETD = linea.split(':')[1].split('%')[0].replaceAll('/','-'); 
                }catch(e){}
                } else if(index===49){
                  //  transitTime = linea.split('(')[1].split(')')[0]; 
                } else if(index===69 || index==71){
                    try{
                        if(index===69)
                          ETA = linea.split(':')[1].split('%')[0].replaceAll('/','-'); 
                        if(index===71 && ETA==='')
                            ETA = linea.split(':')[1].split('%')[0].replaceAll('/','-');
                }catch(e){}
                } else if(index===63 || index===65){
                    try{
                        if(index===63)
                          destino = linea.split(':')[1].split(',')[0].trim(); 
                        if(index===65 && destino==='')
                            destino = linea.split(':')[1].split(',')[0].trim(); 
                }catch(e){}
                } else if((index===100 || index===102 || index===103 || index===104 || index===105 || index===107 || index===112 || (index===494 && !linea.includes('QUANTIDADE') && !linea.includes('===')) || (index===498) || index===502) && cantidadContenedores===''){
                    try{
                        if((index===100 && linea.includes(' /')) && !linea.includes('=') && !linea.includes(':') && !linea.includes('(') && !linea.includes('% %'))
                           cantidadContenedores = linea.split('%')[1].split(' ')[0].trim(); 
                        if(index===102 && cantidadContenedores==='' && !linea.includes('% %') && !linea.includes(' ') && !linea.includes('='))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===103 && cantidadContenedores==='' && !linea.includes('=') && !linea.includes('/') && !linea.includes('(') && !linea.includes(' '))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===104 && cantidadContenedores==='' && !linea.includes('=') && !linea.includes('% %') && !linea.includes('-'))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===105 && cantidadContenedores==='' && linea.includes('HI-CUBE'))
                            cantidadContenedores = linea.split('%')[1].split(' ')[0].trim(); 
                        if(index===105 && cantidadContenedores==='' && !linea.includes('/') && !linea.includes('% %'))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===107 && cantidadContenedores==='' && linea.includes('HI-CUBE'))
                            cantidadContenedores = linea.split('%')[1].split(' ')[0].trim(); 
                        if(index===107 && cantidadContenedores==='' && !linea.includes('% %'))
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                        if(index===112 && cantidadContenedores==='')
                            cantidadContenedores = linea.split('%')[1].split('%')[0].trim(); 
                }catch(e){}
                } else if(index===52 || index===54){
                    try{
                        if(index===52)
                          DLC = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
                        if(index===54 && DLC==='')
                            DLC = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
                }catch(e){}
                } else if(index===53 || index===55){
                    try{
                        if(index===53)
                          DLD = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
                       else if(index===55 && DLD==='')
                          DLD = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
                }catch(e){}
                }
               
                
        });
        var porigen = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase()).includes(origen.toUpperCase()))?.id_puerto || -1;
        var pdestino = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase()).includes(destino.toUpperCase()))?.id_puerto || -1;
        print('porigen: '+porigen+' pdestino: '+pdestino)

          setFormData({ ...formData, codigo:codreferencia, nro_booking:nroBooking, nave:navio,etd:ETD,eta:ETA, cantidad:cantidadContenedores, id_carrier:6, id_puerto_origen:porigen,id_puerto_destino:pdestino, dlc: DLC, dld: DLD});
    }
        
      extractedText += pageText;
    }
  } catch (error) {
    throw new Error(`Failed to extract text from PDF: ${error}`);
  } finally {

    URL.revokeObjectURL(blobUrl);
    // Free memory from loading task
    loadingTask.destroy();
  }

      }

    const handleUploadEverGreen1 = async (e) => {
        e.preventDefault()
        const reader = new FileReader()

        var codreferencia = "";
        var nroBooking = "";
        var text = "";
        var navio = "";
        var origen = "";
        var ETD = "";
        var transitTime = "";
        var destino = "";
        var ETA = "";
        var cantidadContenedores = "";
        var freeTimeOrigen = "";
        var freeTimeDestino= "";
        var DLC= "";
        var DLD= "";

        reader.onload = async (e) => { 
          text = (e.target.result)
          var array = new Int8Array(text);

          //try{
          text.split('\n').forEach((linea, index)=>{
            //print(index+' '+linea)

            if(index===310 || index===341){
                try{
                codreferencia = linea.split('.:')[1].split(')')[0];
                nroBooking = linea.split('(')[1].split('A')[0].trim();  
            }catch(e){}
            } 
             else if(index===320 || index===351){
                try{
                navio = linea.split('(')[1].split(')')[0]; 
            }catch(e){}
            } else if(index===332 || index===418){
                try{
                origen = linea.split(':')[1].split(',')[0].trim(); 
            }catch(e){}
            } else if(index===403 || index===434){
                try{
                ETD = linea.split(':')[1].split(')')[0].replaceAll('/','-'); 
            }catch(e){}
            } else if(index===49){
              //  transitTime = linea.split('(')[1].split(')')[0]; 
            } else if(index===419 || index===450){
                try{
                      ETA = linea.split(':')[1].split(')')[0].replaceAll('/','-'); 
            }catch(e){}
            } else if(index===411 || index===442){
                try{
                      destino = linea.split(':')[1].split(',')[0].trim(); 
            }catch(e){}
            } else if((index===467 || index===475 || (index===494 && !linea.includes('QUANTIDADE') && !linea.includes('===')) || (index===498) || index===502) && cantidadContenedores===''){
                try{
                       cantidadContenedores = linea.split('(')[1].split(' ')[0].trim(); 
            }catch(e){}
            } else if(index===391 || index===422){
                try{
                      DLC = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
            }catch(e){}
            } else if(index===395 || index===426){
                try{
                      DLD = linea.split(':')[1].split(' ')[0].replaceAll('/','-'); 
            }catch(e){}
            }
            

            /*
            SIRVE PARA FFW RST INTERNATIONAL LOGISTICS
            if(index===35){
                armador = linea.split('(')[1].split(')')[0];           
            } else if(index===48){
                navio = linea.split('(')[1].split(')')[0]; 
            } else if(index===31){
                origen = linea.split('(')[1].split(')')[0]; 
            } else if(index===33){
                ETD = formatYYYYMMDD(linea.split('(')[1].split(')')[0].replaceAll('/','-')); 
            } else if(index===49){
                transitTime = linea.split('(')[1].split(')')[0]; 
            } else if(index===34){
                ETA = linea.split('(')[1].split(')')[0]; 
            } else if(index===32){
                destino = linea.split('(')[1].split(')')[0]; 
            } else if(index===76){
                cantidadContenedores = linea.split('(')[1].split(')')[0]; 
            } else if(index===78){
                freeTimeOrigen = linea.split('(')[1].split(')')[0]; 
            } else if(index===79){
                freeTimeDestino = linea.split('(')[1].split(')')[0]; 
            }
          */
            
        });
    //} catch(e){
    //    alert(`Favor revisar PDF que corresponda a empresa`);
   // }

        var porigen = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase()).includes(origen.toUpperCase()))?.id_puerto || -1;
        var pdestino = puertos.find(puerto => eliminarDiacriticosEs(puerto.nombre.toUpperCase()).includes(destino.toUpperCase()))?.id_puerto || -1;
        print('porigen: '+porigen+' pdestino: '+pdestino)

          setFormData({ ...formData, codigo:codreferencia, nro_booking:nroBooking, nave:navio,etd:ETD,eta:ETA, cantidad:cantidadContenedores, id_carrier:6, id_puerto_origen:porigen,id_puerto_destino:pdestino, dlc: DLC, dld: DLD});
          //alert(text)
        };
       reader.readAsText(e.target.files[0]);


/*
        print('reading input file:');
        const file = e.target.files[0];
        const data = await file.arrayBuffer();
        print(data);
        */
        //print(workbook);
        //print(jsonData);
    }

    /* const CalcularPrecioFlete = () => {
        const [show, setShow] = React.useState(false);
        const [valor, setValor] = React.useState(0);
      
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);

        const handleChange1 = (e) => {
            const { name, value } = e.target;
            setValor(value);
        };
      
        return (
          <>
            <Button variant="outline-primary" onClick={handleShow}>
              Calcular Precio Flete
            </Button>
      
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Calcular Precio Flete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <div class="row">
    <div class="col">         
    <div className="mb-3">
                                <label className="form-label">Tipo de Cambio</label>
                                <input type="number" step="0.01" className="form-control"  onChange={handleChange1} value={valor}/>
                            </div>
                            <div class="col">  
                            <div className="mb-3">
                            Puerto Origen: {puertos.find(puerto => puerto.id_puerto === formData.id_puerto_origen)?.nombre}
                            Cantidad Containers: {formData.cantidad} 
                            </div></div>
                            </div>
                            </div>

              <p>
              {valor*2}
                </p>              

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
      };
      */
//handleShow
    const LeerPDFs = () => {
        const [show, setShow] = React.useState(false);
      
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(true);
      
        return (
          <>
            <Button variant="outline-primary" onClick={handleShow}>
              Leer PDF
            </Button>
      
            <Modal show={show} onHide={handleClose} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Carga un PDF</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              Leer PDF Evergreen           
              <input type="file" accept="application/pdf" onChange={handleUploadEverGreen} />
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Volver
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        );
      };

  
      const handleSubmit1 = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
    
        //setValidated(true);
      };


    return (
        <>
          <Modal dialogClassName="my-modal" size='xl' aria-labelledby="contained-modal-title-vcenter"
      centered show={cerrar} backdrop="static">
            <Modal.Header>
            <div className="d-flex">
                    <div className="p-11 align-self-center">
                        <h5 className="modal-title">Agregar Solicitud de Booking</h5>
                        </div>
                        <div className="p-1 align-self-start">
                       
      </div></div>

                        <button type="button" className="btn-close" onClick={cerrar}></button>
            </Modal.Header>
            <Modal.Body>

    <Form onSubmit={handleSubmit1}>
    <Alert key='success' variant='success'>
    Crea una solicitud externa a partir de una solicitud interna, leyendo un PDF y/o rellenando manualmente.
        </Alert>             
                    
   <div className="container">
  <div className="row">
    <div className="col-4">
    <div className="mb-3">
                                <label className="form-label">Solicitud Interna Asociada</label>
                                <select
                                    className="form-select"
                                    name="id_solicitud_interna"
                                    onChange={handleChangeSolicitudInterna}
                                    value={formData.id_solicitud_interna}

                                >
                                    <option value="-1">Sin Solicitud Interna</option>
                                    {solicitudesInternas.map((item) => {
                                        if(item.estado === 1){
                                            return (
                                                <option key={item.id_solicitudinterna} value={item.id_solicitudinterna}>
                                                    {item.codigo} - {item.cantidad-item.cantidad_solicitada} contenedores
                                                </option>
                                            );
                                        }
                                    })}
                                </select>
                            </div>
        </div>
        <div className="col-4">
        <div className="containerTitulo">
        <span className="titleTitulo">Opciones</span>
        <div className="row">
        <div className="col"> 
        <LeerPDFs/> 
       
        </div>
    {/*<button type="submit"className="btn btn-primary btn-lg" style={{ flex: 1}}>Guardar Solicitud de Booking</button> */}
    </div>
       
       
        
</div>
        </div>
        <div className="col-4 text-center"><EnviarCorreoBooking /></div>
       <p></p>
       <hr></hr>
        </div>
        <div className="row">
    <div className="col">         
    <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Referencia {formData.codigo.trim()==='' ? '' : '✅'}</label>
                                <input type="text" className="form-control" name="codigo" onChange={handleChangeUpperCase} value={formData.codigo}  required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label"  style={{fontWeight:'bold'}}>ETD {formData.etd==='' ? '' : '✅'}</label>
                                <input type="date" className="form-control" name="etd" onChange={handleChange} value={formData.etd} required />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">DLD {formData.dld===null ? '' : '✅'}</label>
                                <input type="date" className="form-control" name="dld" onChange={handleChange} value={formData.dld}/>
                            </div>
                            
                            <div className="mb-3">
                                <label className="form-label">FFW</label>
                                <select
                                    className="form-select"
                                    name="id_ffw"
                                    onChange={(e) => handleChange({ target: { name: "id_ffw", value: e.target.value || null } })}
                                    value={formData.id_ffw || ""}
                                >
                                    {ffw.map((item) => (
                                        <option key={item.id_ffw} value={item.id_ffw}>
                                            {item.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {formData.id_ffw === null || formData.id_ffw === "" ? (
                                <div className="mb-3">
                                    <label className="form-label">Carrier</label>
                                    <select
                                        className="form-select"
                                        name="id_carrier"
                                        onChange={handleChange}
                                        value={formData.id_carrier}
                                    >
                                        <option value="">Seleccione un Carrier</option>
                                        {carriers
                                            .filter((carrier) => carrier.tipo === 2) // Filtra los carriers tipo 2
                                            .map((item) => (
                                                <option key={item.id_carrier} value={item.id_carrier}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            ) : (
                                <div className="mb-3">
                                    <label className="form-label" style={{fontWeight:'bold'}}>Carrier</label>
                                    <select
                                        className="form-select"
                                        name="id_carrier"
                                        onChange={handleChange}
                                        value={formData.id_carrier}
                                    >
                                        <option value="">Seleccione un Carrier</option>
                                        {carriers
                                            .filter((carrier) => carrier.tipo === 1) // Filtra los carriers tipo 1
                                            .map((item) => (
                                                <option key={item.id_carrier} value={item.id_carrier}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            )}
                            <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Puerto Origen</label>
                                <select
                                    className="form-select"
                                    name="id_puerto_origen"
                                    onChange={handleChange}
                                    value={formData.id_puerto_origen}
                                >
                                    <option value="">Seleccione un Puerto</option>
                                    {puertos
                                        .filter((puerto) => puerto.indicador === 1 || puerto.indicador === 3) // Filtra puertos origen
                                        .map((item) => (
                                            <option key={item.id_puerto} value={item.id_puerto}>
                                                {item.nombre}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            
                            <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Free Time Origen {formData.ftorigen==='' ? '' : '✅'}</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ftorigen"
                                    onChange={handleChange}
                                    value={formData.ftorigen}
                                    placeholder="Días"
                                    required
                                />
                            </div>
                          



    </div>
    
    <div className="col">
    <div className="mb-3">
                                <label className="form-label">N° Booking {formData.nro_booking.trim()==='' ? '' : '✅'}</label>
                                <input type="text" step="0.01" className="form-control" name="nro_booking" onChange={handleChange} value={formData.nro_booking} />
                            </div>
    <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Flete USD {formData.flete==='' ? '' : '✅'}</label>
                                <input type="number" step="0.01" className="form-control" name="flete" onChange={handleChange} value={formData.flete} required />
                            </div>

    
                            <div className="mb-3">
                                <label className="form-label">DLC {formData.dlc===null ? '' : '✅'}</label>
                                <input type="date" defaultValue='' className="form-control" name="dlc" onChange={handleChange} value={formData.dlc}/>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">ETA {formData.eta===null ? '' : '✅'}</label>
                                <input type="date" defaultValue='' className="form-control" name="eta" onChange={handleChange} value={formData.eta}/>
                            </div>
                           
                            <div className="mb-3">
                                <label className="form-label">Nave {formData.nave.trim()==='' ? '' : '✅'}</label>
                                <input type="text" defaultValue='' className="form-control" name="nave" onChange={handleChange} value={formData.nave} required />
                            </div>
                          <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Puerto Destino</label>
                                <select
                                    className="form-select"
                                    name="id_puerto_destino"
                                    onChange={handleChange}
                                    value={formData.id_puerto_destino}
                                >
                                    <option value="">Seleccione un Puerto</option>
                                    {puertos
                                        .filter((puerto) => puerto.indicador === 2 || puerto.indicador === 3) // Filtra puertos destino
                                        .map((item) => (
                                            <option key={item.id_puerto} value={item.id_puerto}>
                                                {item.nombre}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Free Time Destino {formData.ftdestino==='' ? '' : '✅'} </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="ftdestino"
                                    onChange={handleChange}
                                    value={formData.ftdestino}
                                    placeholder="Días"
                                    required
                                />
                            </div>
                          
                           
                          

    </div>
    <div className="col">

    <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Cantidad de Contenedores {solicitudInterna && cantidadMaxima && (`(Max: ${cantidadMaxima})`)} {formData.cantidad==='' || cantidadMaxima<formData.cantidad ? '' : '✅'}</label>
                                <input type="number" className="form-control" name="cantidad" onChange={(e) => handleChangeCantidad(e, 100)} value={formData.cantidad} min="1" maxlength="2" max={cantidadMaxima} required />
                            </div>
                           
                            

     <div className="mb-3">
                                <label className="form-label" style={{fontWeight:'bold'}}>Peso de Carga {formData.cargo_weight.trim()==='' ? '' : '✅'}</label>
                                <input type='text' className="form-control" name="cargo_weight" onChange={handleChange} value={formData.cargo_weight} required/>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Tipo de Carga</label>
                                <select className="form-select" name="tipo_carga" onChange={handleChange} value={formData.tipo_carga}>
                                    <option value="40HC Supertestado">40HC Supertestado</option>
                                </select>
                            </div>


                            <div className="mb-3">
                                <label className="form-label">Tipo</label>
                                <select className="form-select" name="tipo_bl" onChange={handleChange} value={formData.tipo_bl}>
                                    <option key="BL Original" value="BL Original">
                                    BL Original  </option>
                                    <option key="Express Release" value="Express Release">
                                    Express Release
                                            </option>   

                                </select>
                            </div>
                        
                           
    <div className="mb-3">
                                <label className="form-label">Requerimientos Especiales</label>
                                <textarea rows="8" className="form-control" name="requerimientos" onChange={handleChange} value={formData.requerimientos}></textarea>
                            </div>
    </div>
    
  <div className="col-4">
    <Card>
    <Card.Body>
    <div className="mb-3"><h5>Calcular Precio de Flete</h5></div> 
    <div className="mb-3">
                                <label className="form-label">Tipo de Cambio</label>
                                <input type="number" step="0.01" className="form-control" id="filter" name="filter" onChange={event => setFilter(event.target.value)} value={filter}/>
   </div>
   <div className="mb-3">
   <div className="list-group" style={{ height: '400px',overflowY: 'scroll', margin:0 ,padding:0 }}>
    {dataCalcularTasas.filter(f => { 
        //print(f);
       // print(`idflete; ${f.idflete} ,,, idtasa ${f.idtasa}  ((item.totalbrsxctnr/Number(filter))+item.totalusdxctnr) ${((f.totalbrsxctnr/Number(filter))+f.totalusdxctnr)} ,,, (item.totalbrsxbl/Number(filter)+item.totalusdxbl) ${(f.totalbrsxbl/Number(filter)+f.totalusdxbl)}`);
       return (filter!=="" && formData.cantidad!=="" && formData.id_puerto_origen.toString()===f.pol.toString() && formData.id_puerto_destino.toString()===f.pod.toString())}).sort((item, item1) => ((((item.totalbrsxctnr/Number(filter))*formData.cantidad))+((item.totalbrsxbl/Number(filter)))+((item.totalusdxctnr*formData.cantidad)+(item.frete*formData.cantidad))+(item.totalusdxbl)) > ((((item1.totalbrsxctnr/Number(filter))*formData.cantidad))+((item1.totalbrsxbl/Number(filter)))+((item1.totalusdxctnr*formData.cantidad)+(item1.frete*formData.cantidad))+(item1.totalusdxbl)) ? 1 : -1)
    .map(item => {
      return (
        <a className={`list-group-item list-group-item-action ${precioSeleccionado===(item.idflete*10+item.idtasa*100) ? "active" : ""}`}
          key={item.idflete*10+item.idtasa*100}
          style={{ listStyleType: 'none'}} onClick={() => seleccionarCalculoTasa(item)}>
          <div>
          <div style={{ fontSize: "14px"}}> {ffw.find(ffw => ffw.id_ffw===item.ffw)?.nombre}</div>
          <div style={{ fontSize: "14px", fontWeight:"bold"}}> {carriers.find(c => c.id_carrier===item.armador)?.nombre}</div>
          <Container>
      <Row>
        <Col>FTO: {item.freetime_origen}</Col>
        <Col>FTD: {item.freetime_destino}</Col>
      </Row>
      </Container>

      <Table striped bordered hover>
      <tbody>
        <tr>
        <td>Total BRL</td>
        <td>R{formatCurrency((((item.totalbrsxctnr)*formData.cantidad))+((item.totalbrsxbl)))}</td>
        </tr>
        <tr>
          <td>Total Flete</td>
          <td>USD{formatCurrency(item.frete*formData.cantidad)}</td>
        </tr>
        <tr>
        <td>Total Flete + Tasa</td>
        <td>USD{formatCurrency(((item.totalusdxctnr*formData.cantidad)+(item.frete*formData.cantidad))+(item.totalusdxbl))}</td>
         </tr>
        <tr>
         <td>TOTAL en USD</td>
          <td>USD{formatCurrency(((((item.totalbrsxctnr/Number(filter))*formData.cantidad))+((item.totalbrsxbl/Number(filter)))+((item.totalusdxctnr*formData.cantidad)+(item.frete*formData.cantidad))+(item.totalusdxbl)))}</td>
        </tr>
        </tbody>
        </Table>
            
            </div>
        </a>
      );
    })}
  </div>
   </div>
   </Card.Body>
    </Card> 
    <p></p>
 
  </div>
  </div>
        </div>
                 
</Form>
            </Modal.Body>
        
          </Modal>
        </>
      );
};

export default AgregarSolicitud;
